import a_bank from "../../images/installment-payment/a_bank.svg";
import mono from "../../images/installment-payment/mono.svg";
import otp from "../../images/installment-payment/otp.svg";
import privat from "../../images/installment-payment/privat.svg";
export const installmentIcons: Record<string, string> = {
    "mono": mono,
    "privat": privat,
    "a_bank": a_bank,
    "otp": otp,
};